export default "__VITE_ASSET__CMlGkRWX__"